import React, { useEffect, useRef, useState } from 'react';
import { Text } from '../text/Text.tsx';
import './TopBar.scss';
import IMG_PC from '../../resource/pc.png';

export const TopBar: React.FC = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className={`topbar active`}>
      <div className="title">
        <img
          src={IMG_PC}
          alt="Retro computer"
          style={{ width: 20 }}
          loading="lazy"
        />
        <div style={{ width: 8 }}/>
        <Text variant="body">{'Xin chào - Hello!'}</Text>
      </div>
      <div className="clock">
        <Text variant="body">
          {time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </Text>
      </div>
    </div>
  );
};
